import styled from 'styled-components'
import { Button } from '@components/Button'
import { Input } from '@components/Field'
import { Pill } from '@components/Pill'
import { black, textMuted } from '@/theme/colors'
import { text } from '@/theme/typography'

export const PickerBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-height: 0;
`

/** The type tabs, scrolling sideways when they don't fit. */
export const Tabs = styled.div`
	display: flex;
	gap: 6px;
	overflow-x: auto;
	padding-bottom: 2px;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
`

export const TabButton = styled(Button).attrs<{ $selected: boolean }>(({ $selected }) => ({
	variant: $selected ? 'primary' : 'secondary',
	size: 'sm',
}))<{ $selected: boolean }>`
	flex-shrink: 0;
`

export const SearchRow = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`

export const SearchGlyph = styled.span`
	position: absolute;
	left: 12px;
	display: inline-flex;
	color: ${textMuted};
	pointer-events: none;
`

export const SearchInput = styled(Input)`
	padding-left: 38px;
`

export const Rows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	max-height: 50vh;
	overflow-y: auto;
`

export const RowText = styled.span`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`

export const RowTitle = styled.span`
	${text.labelSm}
	color: ${black};
	overflow-wrap: anywhere;
`

export const RowFacts = styled.span`
	display: flex;
	align-items: center;
	gap: 6px;
	min-width: 0;
`

export const RowDetail = styled.span`
	${text.caption}
	font-weight: 400;
	color: ${textMuted};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const RowPill = styled(Pill).attrs({ $tone: 'accent', $size: 'sm' })``
